
import { SiCircuitverse } from "react-icons/si";
import { PiChartLineUpBold } from "react-icons/pi";
import { MdOutlineSettingsSuggest, MdCastForEducation } from "react-icons/md";


const Content = [
 
  {
    id: 1,
    icon: <SiCircuitverse/>,
    alt: "icon",
    title: "Software",
    text: "Automate, Integrate and Elevate your business operations with our Ready-to-Launch Software-as-a-Service offerings.",
    path:"/partners",
    list:["Enterprise Asset Managment","Entrprise Service Managment","Financial ERP", "Inspection Managment","Low-Code/ No-Code Platform","Customer/Vendor Regn","Field Force Management","Custom App Development  ","Application Maintenance"]
  },
  {
    id: 2,
    icon: <PiChartLineUpBold/>,
    alt: "icon",
    title: "AI & GenAI",
    text: "Unlock the power of AI and GenAI: where intelligent algorithms meet creative generation, driving innovation and transforming your business into the future.",
    path:"/partners",                                               
    list:["AI Chatbots","Intelligent Automation" ]
  },
  {
    id: 3,
    icon: <MdOutlineSettingsSuggest/>,
    alt: "icon",
    title: "Cloud",
    text: "We bridge the gap to the cloud, offering expert system integration, migration, provisioning and management, so you can focus on your core business, not your IT infrastructure.",
    path:"/partners",
    list:["Infratsructure-as-a-Service","Cloud Management","Cloud Migration" ]
  },
  {
    id: 4,
    icon: <MdCastForEducation/>,
    alt: "icon",
    title: "Partner Products",
    text: "We also offer our Partner's products",
    path:"/partners",
    list:["Adobe Creative Cloud", "Adobe Document Cloud","Adobe Experience Cloud","Corel","Smart Classrooms","Unified End-Point Management","Web Application Firewall"]
  },
];
export default Content;
